<template>
  <div>
    <VideoTrack v-if="screenShare.video" v-bind:track="screenShare.video" />
    <AudioTrack v-if="screenShare.audio" v-bind:track="screenShare.audio" />
    <div class="name">
      {{ screenShare.user_name }}
    </div>
  </div>
</template>

<script>
import VideoTrack from "@/components/VideoTrack";
import AudioTrack from "@/components/AudioTrack";

export default {
  name: "ScreenShare",
  components: { AudioTrack, VideoTrack },
  props: ["screenShare"],
};
</script>

<style scoped>
</style>
